var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComplianceXlsxFileExpired = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 47,
  height: 51,
  viewBox: "0 0 47 51",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#9dp0p3bfna)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.313 1.067h29.989l11.466 11.991v33.638c0 .72-.558 1.304-1.247 1.304H3.313c-.688 0-1.246-.584-1.246-1.304V2.37c0-.72.558-1.303 1.246-1.303z",
  fill: "#F0EFEF"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.794 1.58 45.26 13.574H35.04c-.688 0-1.246-.584-1.246-1.304V1.581z",
  fill: "#ABABAB"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.857 17.013h-13.38A2.676 2.676 0 0 0 13.8 19.69v13.208a2.676 2.676 0 0 0 2.676 2.676h13.38a2.676 2.676 0 0 0 2.677-2.676V19.69a2.676 2.676 0 0 0-2.676-2.676z",
  fill: "#ABABAB"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m18.313 31.48 3.399-5.355-3.113-5.325h2.505l1.7 3.404c.155.322.263.563.321.722h.022c.113-.258.23-.508.352-.752l1.816-3.374h2.3l-3.193 5.296 3.274 5.384H25.25l-1.963-3.739a3.14 3.14 0 0 1-.234-.499h-.029c-.034.12-.11.281-.227.485l-2.022 3.753h-2.461z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "9dp0p3bfna",
  x: 0.067,
  y: 0.067,
  width: 46.701,
  height: 50.933,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.300721 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_389_449"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_389_449",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComplianceXlsxFileExpired);
export default ForwardRef;